import React from 'react';
import PhrasesPage from './PhrasesPage';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import Moment from 'moment';
import { connect } from 'react-redux';
import { configureActions } from '../../../../actions/configure.action';
import phrasesActions from '../../../../actions/phrases.actions';
import { bindActionCreators } from 'redux';
import helper from '../../../../utils/helper';
import lookupActions from '../../../../actions/lookup.actions';

class Phrases extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phrases: [],
      departments: [],
      deptId: undefined,
      loading: false,
      isFetching: false,
      isFetchingPhrases: false,
      errors: '',
      openModal: false,
      selectedRow: null,
    };
    this.columns = [{ dataField: 'phrase', text: 'Phrase', sort: true }];
    this.defaultSorted = [
      {
        dataField: 'phrase',
        order: 'asc',
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Edit phrase',
          action: (row, rowIndex) => {
            this.props.history.push(
              `/configure/phrases/edit-phrase/${this.state.deptId}/${row.id}`,
            );
          },
        },
        {
          name: 'Delete phrase',
          action: (row, rowIndex) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.phrases.phrases !== prevState.phrases) {
      state.phrases = nextProps.phrases.phrases;
    }
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    state.errors = helper.centralizeError([
      nextProps.phrases.errors,
      nextProps.lookup.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }

  componentDidMount() {
    window.addEventListener('beforeunload', function (ev) {
      this.props.history.replace('/configure/phrases', null);
    });
    this.setState(
      { loading: true },
      async () =>
        await this.props.lookupActions
          .getDepartments()
          .then(() => this.setState({ loading: false })),
    );
  }

  onChangeDept = (deptId) => {
    this.setState(
      { deptId, isFetchingPhrases: true },
      async () =>
        await this.props.phrasesActions
          .getPhrases()
          .finally(() => this.setState({ isFetchingPhrases: false })),
    );
  };
  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };

  onDeletePhrase = () => {
    const { selectedRow } = this.state;
    this.setState(
      { openModal: false },
      async () =>
        await this.props.phrasesActions
          .deletePhrase(selectedRow.id)
          .then(() =>
            this.setState(
              { isFetchingPhrases: true },
              async () =>
                await this.props.phrasesActions
                  .getPhrases()
                  .finally(() => this.setState({ isFetchingPhrases: false })),
            ),
          ),
    );
  };

  render() {
    const { loading } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <PhrasesPage
        {...this.state}
        routerState={this.props.location.state}
        onChangeDept={this.onChangeDept}
        datagridProps={{
          columns: this.columns,
          defaultSorted: this.defaultSorted,
        }}
        ctxMenuOptions={this.ctxMenuOptions}
        onCancel={this.onCancel}
        onDeletePhrase={this.onDeletePhrase}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    phrases: state.phrases,
    lookup: state.lookup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    phrasesActions: bindActionCreators(
      Object.assign({}, phrasesActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Phrases);
